import { apiInstance } from '@/api/instance';
import { type PostalCodeAddress } from '@/types/location';

/** Address lookup by CEP (ViaCEP behind the API). Only needs a session. */
export const locationApi = {
  getAddressByPostalCode: (postalCode: string) =>
    apiInstance.get<PostalCodeAddress>(`location/postal-code/${postalCode.replace(/\D/g, '')}`),
};
